/**
 * 动态设置 root font-size，配合 postcss-pxtorem 实现 px 自适应
 * 设计稿宽度 1920px，基准 font-size 16px
 */
function setRemUnit() {
  const designWidth = 1920;
  const baseFontSize = 16;
  const minFontSize = 12; // 最小 font-size，防止过小导致布局问题
  const maxFontSize = 20; // 最大 font-size，防止过大导致布局问题
  const { clientWidth } = document.documentElement;
  const fontSize = (baseFontSize * clientWidth) / designWidth;
  // 限制 font-size 在合理范围内
  const clampedFontSize = Math.max(
    minFontSize,
    Math.min(maxFontSize, fontSize)
  );

  document.documentElement.style.fontSize = `${clampedFontSize}px`;
}

setRemUnit();
window.addEventListener('resize', setRemUnit);
